class ProjectHeaderSettingsComponent extends HTMLElement {

  titleText = 'New Anchor Bolt Design'
  companyName = 'Your Company Name'

  constructor() {
    super();
    document.addEventListener('project-loaded', (event) => this.onUpdate(event.detail), true)
  }

  onChange() {
    let titleText = document.getElementById('project-title-header-settings-text-input').value
    if(titleText === '') {
      document.getElementById('modal-project-header-settings-error').innerHTML = "Title can't be blank."
      document.getElementById('modal-project-header-settings-error').classList.remove('d-none')
    } else {
      document.getElementById('modal-project-header-settings-error').classList.add('d-none')
    }
  }

  onSave() {
    let titleText = document.getElementById('project-title-header-settings-text-input').value
    if(titleText === '') {
      document.getElementById('modal-project-header-settings-error').innerHTML = "Title can't be blank."
      document.getElementById('modal-project-header-settings-error').classList.remove('d-none')
      return
    }
    if(this.titleText !== titleText) {
      this.titleText = titleText
      const event = new CustomEvent('project-title-changed', { detail: this.titleText });
      this.dispatchEvent(event)
    }

    let companyName = document.getElementById('company-name-header-settings-text-input').value
    if(this.companyName !== companyName) {
      this.companyName = companyName
      // send project settings updated message...
      const event = new CustomEvent('company-name-changed', { detail: this.companyName });
      this.dispatchEvent(event)
    }
  }

  onUpdate(detail) {
    this.titleText = detail.title
    document.getElementById('project-title-header-settings-text-input').value = this.titleText
  }

  get projectTitleText() {
    console.log(document.getElementById('project-title-header-settings-text-input'))
    return document.getElementById('project-title-header-settings-text-input').value
  }

  connectedCallback() {
    this.innerHTML = String.raw`
      <div class="modal fade" id="modal-project-header-settings-dialog" tabindex="-1" role="dialog"
        aria-labelledby="modal-project-header-dialog" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Project Header Settings</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
      
            <div class="modal-body">

              <div id="modal-project-header-settings-error" class="alert alert-danger d-none"></div>
      
              <div class="form-group">
                <label for="project-title-header-settings" class="form-label">Anchor Bolt Design Title</label>
                <input type="text" class="form-control" id="project-title-header-settings-text-input" value="${this.titleText}">
              </div>
      
              <div class="form-group" style="margin-top:10px">
                <label for="company-name-header-settings"class="form-label">Your Company Name</label>
                <input type="text" class="form-control" id="company-name-header-settings-text-input" value="${this.companyName}">
              </div>
      
              <div class="modal-footer">
                <button type="button" class="btn btn-success" data-bs-dismiss="modal"
                  id="modal-project-header-settings-save-button">
                  Save
                </button>
                <button type="button" class="btn btn-default" data-bs-dismiss="modal">Cancel</button>
              </div>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
    `
    document.getElementById('project-title-header-settings-text-input').addEventListener('change', this.onChange)
    document.getElementById('modal-project-header-settings-save-button').addEventListener('click', this.onSave)
  }
}

customElements.define('project-header-settings-component', ProjectHeaderSettingsComponent)